import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Layout from './components/Layout';
import { HomePage } from './features/home/pages/HomePage';
import AdminPage from './features/admin/pages/AdminPage';
import LoginPage from './features/auth/pages/LoginPage';
import { AuthProvider } from './features/auth/contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DeviceManagement from './features/device/components/DeviceManagement';

const AppContent: React.FC = () => {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [subtitle, setSubtitle] = useState('');
  const [showBackNavigation, setShowBackNavigation] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/Projects" element={
          <ProtectedRoute>
            <Layout 
              subtitle={subtitle} 
              showBackNavigation={showBackNavigation} 
              setShowBackNavigation={setShowBackNavigation}
              onCreateClick={() => setShowCreateForm(true)}
              onEditClick={() => setShowCreateForm(true)}
              onBack={() => {
                console.log('onBack');
                setSubtitle('');
                setShowBackNavigation(false);
                setShowCreateForm(false);
                navigate('/Projects', { replace: true });
              }}
            >
              <HomePage 
                showCreateForm={showCreateForm}
                onCreateFormClose={() => setShowCreateForm(false)}
                setSubtitle={setSubtitle}
                setShowBackNavigation={setShowBackNavigation}
                showBackNavigation={showBackNavigation}
              />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminPage />
          </ProtectedRoute>
        } />
        <Route path="/analysis" element={
          <ProtectedRoute>
            <Layout>
              <div className="p-6">
                <h1 className="text-2xl font-bold mb-4">Analysis Dashboard</h1>
                <p className="text-gray-600">Analysis features coming soon...</p>
              </div>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/devices" element={
          <ProtectedRoute>
            <Layout>
              <DeviceManagement />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
};

export default App; 